import React from 'react';
import {withStyles} from "@material-ui/core";
import List from '@material-ui/core/List';
import ListItem from "@material-ui/core/ListItem";

const styles = {
    list: {

    },
    listItem: {
        display:'list-item',
        justifyContent:'center',
        textAlign:'center',
        opacity:0.64,
    }
};

export default withStyles(styles) ( props  => {

    const {
        values,
        listStyles,
        listItemStyles,
    } = props;

    const items = values.messages ? values.messages : [];

    return (
        <List dense={true} disablePadding={true} style={listStyles ?? styles.list}>
            {items.map( (item,key) =>
                <ListItem key={key} style={listItemStyles ?? styles.listItem}>{item}</ListItem>
            )}
        </List>
    );
});
